<template>
  <div class="header">
    <div class="container">
      <img
        src="@/assets/images/version/logo.png"
        alt="骆驼规划"
        class="logo fl"
      />
      <div v-if="type === 1" class="slogan fl">
        省心省钱买对保险
      </div>
      <div v-show="visibleLogin" class="login_button fr">
        <div v-if="!token" @click="gotoLogin" class="no_login">
          登录
        </div>
        <div
          v-else
          @mouseover="() => (loginMenuShow = true)"
          @mouseout="() => (loginMenuShow = false)"
          class="login_info"
        >
          <div class="login_name">{{ name }}</div>
          <i :class="['login_arrow', loginMenuShow ? 'arrow_down' : '']"></i>
          <div v-show="loginMenuShow" class="login_menu">
            <a href="/publish" class="login_item">我的发布</a>
            <a @click="loginOutEvent" class="login_item">退出登录</a>
          </div>
        </div>
      </div>
      <div class="nav">
        <router-link
          v-for="item in menu"
          :to="item.path"
          :key="item.id"
          :class="['nav_item', item.isActive ? 'active' : '']"
          @click="point"
        >
          {{ item.text }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie, setCookie } from "@/utils/tools";
import { login } from "@/service/api/login";
export default {
  name: "Header",
  props: {
    type: {
      default: 1,
      type: Number
    }
  },
  data() {
    return {
      token: "",
      name: "",
      visibleLogin: false,
      loginMenuShow: false,
      menu: [
        { id: 1, text: "首页", path: "/", isActive: true },
        { id: 2, text: "保险咨询", path: "/consult", isActive: false },
        // {
        // 	id: 5,
        // 	text: '保险课堂',
        // 	path: '/ketang',
        // 	isActive: false
        // },
        {
          id: 3,
          text: "信息披露",
          path: "/information/51",
          isActive: false
        },
        { id: 4, text: "关于我们", path: "/about/41", isActive: false }
      ]
    };
  },
  mounted() {
    this.changeType(this.type);
    this.token = getCookie("luo_token") || "";
    this.name = getCookie("luo_name") || "";
    this.visibleLogin = false;
  },
  watch: {
    type(n) {
      let _arr = this.menu.map(o => {
        o.isActive = o.id === n;
        return o;
      });
      this.menu = _arr;
    }
  },
  methods: {
    changeType(n) {
      let _arr = this.menu.map(o => {
        o.isActive = o.id === n;
        return o;
      });
      this.menu = _arr;
    },
    gotoLogin() {
      window.location.href =
        "/user/login?redirect=" + encodeURIComponent(window.location.href);
    },
    loginOutEvent() {
      this.$axios
        .post(login.logout, { loginToken: this.token })
        .then(response => {
          let res = response.data;
          if (res.result === 0) {
            setCookie("luo_token", "");
            setCookie("luo_name", "");
            window.location.reload();
          } else {
            this.$toast.info(res.resultMessage);
          }
        })
        .catch(() => {
          this.$toast.info("网络有点小拥堵，请重试");
        });
    },
    point(name) {
      const sensorData = {
        url: window.location.href
      };
      switch (name) {
        case "首页":
          sensorData.param1 = "menu";
          sensorData.tgt_name = "PC官网_首页";
          sensorData.tgt_event_id = "bxWeb_home_menu";
          sensorData.page = "PC官网_首页";
          break;
        case "保险咨询":
          sensorData.tgt_name = "PC官网_咨询";
          sensorData.tgt_event_id = "bxWeb_consult_menu";
          sensorData.page = "PC官网_咨询";
          break;
        case "保险课堂":
          sensorData.tgt_name = "PC官网_课堂";
          sensorData.tgt_event_id = "bxWeb_class_menu";
          sensorData.page = "PC官网_课堂";
          break;
        case "信息披露":
          sensorData.tgt_name = "PC官网_信息披露";
          sensorData.tgt_event_id = "bxWeb_disclosure_menu";
          sensorData.page = "PC官网_信息披露";
          break;
        case "关于我们":
          sensorData.tgt_name = "PC官网_关于我们";
          sensorData.tgt_event_id = "bxWeb_aboutus_menu";
          sensorData.page = "PC官网_关于我们";
          break;
        default:
          break;
      }
      this.$point("h5_clk", sensorData);
    }
  }
};
</script>
